import React, { PureComponent } from 'react'
import CheckDefecto from "../../../Common/Components/CheckDefecto"
import SelectCommon from '../../NuevaSolicitudCuenta/components/Common/SelectCommonDefault'

class TipoVigencia extends PureComponent {

    render() {
        const {data, tarjetas, selectCheckBox, tarjetasTemporales, selectCombo}=this.props
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <label className="label-primary">{"Tipo de Vigencia"}</label>
                    <CheckDefecto
                         nombre={"Tarjeta Temporal"}
                         check={data.seleccionaTarjetaTemporal}
                         referencia={"sel"}
                         selectCheckBox={(event) => selectCheckBox("seleccionaTarjetaTemporal", event.target.checked)}
                    />
                    {data.seleccionaTarjetaTemporal && <div className="row">
                        <div className="col-xs-5">
                            <SelectCommon 
                                    valorCombo={undefined}
                                    selecciones={data}
                                    infoData={tarjetasTemporales} 
                                    selectCombo={selectCombo}
                                    nombreAction={"vigenciaTemporalId"}
                             />
                                    {/*FALTA OBTENCION DE DATOS DE LAS TARJETAS TEMPORALES */}
                      

                        </div>
                    </div>}
                </div>
                <div className="col-md-12">
                {(data.ERROR_ADICIONAL["seleccionoTipoVigencia"] == false)
                    && <label className="error">{"Debe seleccionar un tipo de vigencia"}</label>} 
                </div>
            </div>
        )
    }
};

export default TipoVigencia;